import { typography, surfaces, utils } from "../../styles/index";
import { useMobileContext } from "../../context/MobileContext";

/**
 * Reusable list section template
 * Used inside workspace pages (Rates, Settings)
 */
export default function ListSectionTemplate({
  title,
  actions,
  filters,
  loading,
  empty,
  emptyText = "No items found.",
  children,
}) {
  const isMobile = useMobileContext();

  return (
    <div>
      {/* Section header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <h2 style={typography.h3}>{title}</h2>

        {/* ✅ RIGHT-ALIGNED ACTIONS */}
        {actions && (
          <div
            style={{
              display: "flex",
              gap: 8,
              justifyContent: isMobile ? "flex-start" : "flex-end",
              flexWrap: "wrap",
              width: isMobile ? "100%" : "auto",
            }}
          >
            {actions}
          </div>
        )}
      </div>

      {/* Filters */}
      {filters && <div style={{ marginBottom: 16 }}>{filters}</div>}

      {/* Content */}
      {loading ? (
        <p>Loading…</p>
      ) : empty ? (
        <div
          style={{
            ...surfaces.card,
            textAlign: "center",
          }}
        >
          {emptyText}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
